module.exports = __webpack_public_path__ + "static/media/FL_BNobleM_en.4bc6cc2b.png";